export default (props, vars) => vars?.loop?.item?.icon === 'link';
